import { useUserContext } from "@/components/user-context/user-context-provider";

import { LoggedOutConfluenceFree } from "./free/logged-out-confluence-free";
import { LoggedOutConfluencePremium } from "./premium/logged-out-confluence-premium";
import { LoggedOutConfluenceStandard } from "./standard/logged-out-confluence-standard";

export const LoggedOutConfluence = () => {
    const { edition } = useUserContext();

    switch (edition) {
        case "premium":
            return <LoggedOutConfluencePremium />;
        case "standard":
            return <LoggedOutConfluenceStandard />;
        default:
            return <LoggedOutConfluenceFree />;
    }
};
